import React from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import 'moment/locale/ko'

// styles
import colors from '../../styles/colors'

// images
import NewButton from '../../assets/image/button/ico-new.svg'
import DownImg from '../../assets/image/arrow/ic-down.svg'

export default function Announcement({ announcementData, isNew }) {
  const navigate = useNavigate()
  // console.log('announcementData!' + JSON.stringify(announcementData?.noticeId))
  const formatDate = (date) => {
    if (!date) return ''

    return `${date.substr(0, 4)}-${date.substr(4, 2)}-${date.substr(
      6,
      2,
    )} ${date.substr(8, 2)}:${date.substr(10, 2)}`
  }

  return (
    <Container
      onClick={() => {
        if (announcementData?.noticeId) {
          navigate(`/happyOrderNoticeList/${announcementData.noticeId}`, {
            state: {
              modified: announcementData.modified,
            },
          })
        }
      }}
    >
      <Wrapper>
        <NoticeTitle>
          {announcementData?.noticeId != null || undefined ? (
            <>
              {isNew && <img src={NewButton} />}
              <span>{announcementData?.ntcTitle ?? ''}</span>
            </>
          ) : (
            '등록된 공지사항이 없습니다.'
          )}
        </NoticeTitle>

        {announcementData?.noticeId && (
          <MoArrowWrapper>
            <img src={DownImg} />
          </MoArrowWrapper>
        )}

        {announcementData?.noticeId && (
          <NoticeDateBtn>
            {formatDate(announcementData?.modified) ?? ''}
            <ArrowWrapper src={DownImg} />
          </NoticeDateBtn>
        )}

        {/* <Date>{formatDate(announcementData?.modified) ?? ''}</Date> */}
      </Wrapper>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  min-width: 320px;
  max-width: 477px;
  padding: 0 30px 0 15px;

  height: 98px;
  object-fit: contain;
  border-radius: 15px;
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.1);
  background-color: ${colors.W1};
  display: flex;
  align-items: center;
  cursor: pointer;

  @media ${(props) => props.theme.tablet} {
    max-width: 482px;
  }

  @media (max-width: 800px) {
    align-self: center;
    padding: 0 30px 0 15px;
  }

  @media ${(props) => props.theme.mobile} {
    max-width: 320px;
    height: 95px;
    padding: 20px;
    margin: 0;
  }
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 15px;
  width: 100%;
  /* flex: 0 0 25px; */
  justify-content: space-between;

  @media ${(props) => props.theme.mobile} {
    flex-direction: column;
    padding-left: 0;
    align-items: flex-start;
  }
`

const NoticeTitle = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;

  @media ${(props) => props.theme.mobile} {
    width: 100%;
  }

  img {
    width: 40px;
    height: 20px;
    margin-right: 12px;
  }

  span {
    padding-right: 10px;
    color: ${colors.BK};
    font-size: 14px;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    @media ${(props) => props.theme.mobile} {
      padding-right: 30px;
    }
  }
`

const NoticeDateBtn = styled.div`
  display: flex;
  font-size: 12px;
  color: ${colors.G4};
  justify-content: space-between;
  width: 120px;
  flex-shrink: 0;

  @media ${(props) => props.theme.mobile} {
    padding: 0;
    flex-direction: column-reverse;
  }
`

const AnnouncementWrapper = styled.div`
  width: 100%;
  min-width: 320px;
  max-width: 477px;
  padding: 35px 30px 35px 15px;

  height: 98px;
  object-fit: contain;
  border-radius: 15px;
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.1);
  background-color: ${colors.W1};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  @media ${(props) => props.theme.tablet} {
    max-width: 482px;
  }

  @media (max-width: 800px) {
    align-self: center;
    padding: 35px 30px 35px 15px;
  }

  @media ${(props) => props.theme.mobile} {
    max-width: 320px;
    height: 95px;
    padding: 20px;
    margin: 0;
  }
`

const Title = styled.div`
  display: flex;
  align-items: center;
  flex: 1;

  span {
    padding: 0 10px;

    /* width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; */
  }

  @media ${(props) => props.theme.mobile} {
    margin-bottom: 15px;
    font-size: 14px;
  }
`

const Date = styled.div`
  font-size: 12px;
  color: ${colors.G4};

  @media ${(props) => props.theme.mobile} {
    padding: 0 10px;
  }
`

const TitleAndDateWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: space-between;

  @media ${(props) => props.theme.mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`

const ArrowWrapper = styled.img`
  width: 12px;
  height: 12px;
  transform: rotate(-0.25turn);
  /* margin-left: 12px; */

  @media ${(props) => props.theme.mobile} {
    /* margin-left: 10px; */
    display: none;
  }
`

const MoArrowWrapper = styled.div`
  display: none;
  width: 100%;
  margin-bottom: 6px;

  img {
    width: 12px;
    height: 12px;
    transform: rotate(-0.25turn);
  }

  @media ${(props) => props.theme.mobile} {
    display: flex;
    justify-content: flex-end;
  }
`
